import { FocusEvent, MouseEventHandler, ReactNode } from 'react';
import { ClassNamed, Disableable, Inlined, Sized } from '@optimus-web/common';
import { IconName } from '@optimus-web/icons';

export interface FieldProps extends Disableable, Sized, ClassNamed, Inlined {
    name: string;
    label?: ReactNode;
    required?: boolean;
    forText?: string;
    onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
    onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
    caption?: ReactNode;
    captionIcon?: IconName;
    captionIconHandler?: MouseEventHandler<HTMLButtonElement>;
    captionIconWithTooltip?: ReactNode;
    helper?: React.ReactNode;
    error?: React.ReactNode;
    forwardedRef?: React.Ref<HTMLElement>;
    insideCompoundField?: boolean;
    htmlFor?: string;
}

export interface CompoundFieldProps
    extends Omit<FieldProps, 'onFocus' | 'onBlur' | 'helper' | 'error' | 'forwardedRef' | 'insideCompoundField'> {
    children: Array<React.ReactElement> | React.ReactElement;
}

export interface FieldHeaderProps
    extends Pick<
        FieldProps,
        | 'label'
        | 'required'
        | 'caption'
        | 'captionIcon'
        | 'captionIconHandler'
        | 'captionIconWithTooltip'
        | 'name'
        | 'inline'
        | 'size'
    > {
    $disabled?: boolean;
    fieldWrapperRef: React.RefObject<HTMLElement>;
}
